import { _ as x } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.symbol.description-6025a604.js";
import "./es.object.assign-7e79fd7b.js";
import { c as u } from "./index-8b07dec9.js";
import d, { css as m } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import { useState as H, useRef as q, useEffect as A } from "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as G } from "./getMetrics-953aa4f8.js";
import { AspectRatio as z } from "./aspectRatio.js";
import { a as F } from "./index-5d0f31c6.js";
import { Image as X } from "./image.js";
import { jsx as l, jsxs as D } from "react/jsx-runtime";
import "./es.function.name-b230e7d4.js";
import "./carousel.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { InputState as j, HelperText as J } from "./helperText.js";
import { Label as Q } from "./label.js";
import "./es.array.from-fe752fa6.js";
import "./index-f5b44da3.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import { uniqueId as U } from "./uniqueId.js";
import "./es.date.to-string-6ed49878.js";
import { ScreenReaderOnly as V } from "./screenReaderOnly.js";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./combineRefs-c9ad2c39.js";
import "./useMediaQuery.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./iconButton.js";
import "./button.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./useIsMounted.js";
import "./aria.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useWindowSize.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./tooltip.js";
import "./string-html-forced-a746405b.js";
import "./es.global-this-a7f40ce1.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "./index-f2264f1e.js";
import "./accessibility.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
var Y = ["selected", "disabled", "children", "isInvalid"], Z = /* @__PURE__ */ d.div.withConfig({
  displayName: "selectionsBase__SelectionsBaseWrapper",
  componentId: "sc-1glyh02-0"
})(["&.SelectionsBase{", ";}"], function(i) {
  var e = i.theme, t = e.components.selectionCard, r = e.componentStyles;
  return m(t.SelectionsBase, r);
}), O = function(e) {
  var t = e.selected, r = t === void 0 ? !1 : t, a = e.disabled, p = a === void 0 ? !1 : a, C = e.children, s = e.isInvalid, v = x(e, Y);
  return /* @__PURE__ */ l(Z, Object.assign({
    tabIndex: 0,
    className: u([v == null ? void 0 : v.className, "SelectionsBase", {
      "SelectionsBase--disabled": p,
      "SelectionsBase--selected": !p && !s && r,
      "SelectionsBase--invalid": !p && s
    }])
  }, v, {
    children: C
  }));
}, ee = ["selected", "disabled", "alignContents", "media", "titleProp", "description", "children", "className", "onKeyDown", "onClick"], ie = /* @__PURE__ */ d.div.withConfig({
  displayName: "selectionCard__StyledSelectionCard",
  componentId: "kh61gv-0"
})(["&.SelectionCard{", ";}"], function(i) {
  var e = i.theme, t = e.components.selectionCard, r = e.componentStyles;
  return m(t.SelectionCard, r);
}), oe = /* @__PURE__ */ d.h1.withConfig({
  displayName: "selectionCard__Title",
  componentId: "kh61gv-1"
})(["&.SelectionCard__title{", ";}"], function(i) {
  var e = i.theme.components.selectionCard;
  return m(e.Title);
}), te = /* @__PURE__ */ d.p.withConfig({
  displayName: "selectionCard__Description",
  componentId: "kh61gv-2"
})(["&.SelectionCard__description{", ";}"], function(i) {
  var e = i.theme.components.selectionCard;
  return m(e.Description);
}), re = /* @__PURE__ */ d(z).withConfig({
  displayName: "selectionCard__Media",
  componentId: "kh61gv-3"
})(["&.SelectionCard__media{", ";}"], function(i) {
  var e = i.theme.components.selectionCard;
  return m(e.Media);
}), ne = /* @__PURE__ */ d.div.withConfig({
  displayName: "selectionCard__Body",
  componentId: "kh61gv-4"
})(["&.SelectionCard__body{", ";}"], function(i) {
  var e = i.theme.components.selectionCard;
  return m(e.Body);
}), le = /* @__PURE__ */ d.div.withConfig({
  displayName: "selectionCard__IconContainer",
  componentId: "kh61gv-5"
})(["&.IconContainer{", ";}"], function(i) {
  var e = i.theme.components.selectionCard;
  return m(e.IconContainer);
}), ae = /* @__PURE__ */ d.div.withConfig({
  displayName: "selectionCard__TrailingElementWrapper",
  componentId: "kh61gv-6"
})(["&.TrailingElementWrapper{", ";}"], function(i) {
  var e = i.theme.components.selectionCard;
  return m(e.TrailingElementWrapper);
}), Po = function(e) {
  var t, r, a, p, C, s = e.selected, v = s === void 0 ? !1 : s, $ = e.disabled, S = $ === void 0 ? !1 : $, w = e.alignContents, n = w === void 0 ? "center" : w, o = e.media, h = e.titleProp, P = e.description, I = e.children, W = e.className, k = e.onKeyDown, f = e.onClick, B = x(e, ee), T = G({
    label: "SelectionCard"
  });
  return /* @__PURE__ */ l(O, Object.assign({
    disabled: S,
    selected: v,
    onClick: function(c) {
      S || f(c);
    },
    onKeyDown: function(c) {
      !S && (k == null || k(c)), (c.code === "Enter" || c.code === "Space") && (c.preventDefault(), !S && (f == null || f(c)));
    }
  }, T, B, {
    children: /* @__PURE__ */ D(ie, {
      className: u(["SelectionCard", "SelectionCard--" + n + "Aligned", {
        "SelectionCard--disabled": S,
        "SelectionCard--selected": !S && v,
        "SelectionCard--imageContainer": (o == null || (t = o.imageProp) == null ? void 0 : t.ratio) !== "2/1"
      }, W]),
      children: [(o == null ? void 0 : o.imageProp) && /* @__PURE__ */ l(re, {
        ratio: o.imageProp.ratio || "1/1",
        objectFit: "cover",
        className: u(["SelectionCard__media", !o.imageProp.ratio || o.imageProp.ratio === "1/1" ? "SelectionCard__media--fixed-container" : "SelectionCard__media--with-radius"]),
        children: /* @__PURE__ */ l(X, {
          src: o.imageProp.src,
          alt: o.imageProp.alt
        })
      }), /* @__PURE__ */ D(ne, {
        className: u(["SelectionCard__body", {
          "SelectionCard__body--disabled": S
        }, "SelectionCard__body--" + n + "Aligned"]),
        children: [o != null && o.iconProp && typeof ((r = o.iconProp) == null ? void 0 : r.element) == "string" ? /* @__PURE__ */ l(F, {
          icon: (a = o.iconProp) == null ? void 0 : a.element,
          size: "xxl",
          extended: !0
        }) : (o == null || (p = o.iconProp) == null ? void 0 : p.element) && /* @__PURE__ */ l(le, {
          className: u(["IconContainer--xxLarge"]),
          children: o == null || (C = o.iconProp) == null ? void 0 : C.element
        }), h && /* @__PURE__ */ l(oe, {
          as: (h == null ? void 0 : h.headingLevel) || "h1",
          className: u(["SelectionCard__title", {
            "SelectionCard__title--xlarge": (h == null ? void 0 : h.titleSize) === "xLarge"
          }]),
          children: h == null ? void 0 : h.title
        }), P && /* @__PURE__ */ l(te, {
          className: "SelectionCard__description",
          children: P
        }), I && /* @__PURE__ */ l(ae, {
          className: u("TrailingElementWrapper"),
          children: I
        })]
      })]
    })
  }));
}, pe = ["children", "selected", "disabled", "isInvalid"], ce = /* @__PURE__ */ d.div.withConfig({
  displayName: "selectionTileCompact__SelectionTileCompactWrapper",
  componentId: "sc-1uk4dkl-0"
})(["&.SelectionTileCompact{", ";}"], function(i) {
  var e = i.theme, t = e.components.selectionTileCompact, r = e.componentStyles;
  return m(t.SelectionTileCompact, r);
}), de = function(e) {
  var t = e.children, r = e.selected, a = e.disabled, p = e.isInvalid, C = x(e, pe);
  return /* @__PURE__ */ D(O, Object.assign({
    disabled: a,
    isInvalid: p,
    selected: r,
    "aria-invalid": p,
    "aria-disabled": a
  }, C, {
    children: [/* @__PURE__ */ l(ce, {
      className: u(["SelectionTileCompact", {
        "SelectionTileCompact--disabled": a
      }]),
      children: t.toString().slice(0, 4)
    }), /* @__PURE__ */ l(V, {
      "aria-live": "polite",
      children: r ? "Selected" : ""
    })]
  }));
}, me = ["tiles", "selectedTile", "onSelect", "labelProp", "infoProp", "trailingText", "helperTextProp", "inputState"], se = ["label", "disabled"], ue = "SelectionTileCompactGroup", Ce = /* @__PURE__ */ d.div.withConfig({
  displayName: "selectionTileCompactGroup__SelectionTileCompactGroupWrapper",
  componentId: "cb4l13-0"
})(["&.SelectionTileCompactGroup-Wrapper{", ";}"], function(i) {
  var e = i.theme, t = e.components.selectionTileCompact, r = e.componentStyles;
  return m(t.SelectionTileCompactGroup, r);
}), ve = /* @__PURE__ */ d.div.withConfig({
  displayName: "selectionTileCompactGroup__MainWrapper",
  componentId: "cb4l13-1"
})(["&.SelectionTileCompactGroup__MainWrapper{", ";}"], function(i) {
  var e = i.theme.components.selectionTileCompact;
  return m(e.MainWrapper);
}), Io = function(e) {
  var t, r, a, p, C = e.tiles, s = e.selectedTile, v = e.onSelect, $ = e.labelProp, S = e.infoProp, w = e.trailingText, n = e.helperTextProp, o = e.inputState, h = x(e, me), P = H(s), I = P[0], W = P[1], k = G({
    label: "SelectionTileCompactGroup"
  }), f = q(U(ue)), B = f.current + "_label_id", T = {
    defaultId: (n == null || (t = n.defaultProp) == null ? void 0 : t.id) || "default_" + f.current + "_message_id",
    secondaryId: (n == null || (r = n.secondaryProp) == null ? void 0 : r.id) || "secondary_" + f.current + "_message_id"
  };
  A(function() {
    W(s);
  }, [s]);
  var N = function(_, g) {
    !C[g].disabled && g !== s && (v == null || v(_, g), W(g));
  }, c = B;
  n != null && (a = n.defaultProp) != null && a.helperText && (c += " " + T.defaultId), o && o !== j.NONE && n != null && (p = n.secondaryProp) != null && p.helperText && (c += " " + T.secondaryId);
  var E = function() {
    return /* @__PURE__ */ l(Q, {
      labelProp: Object.assign({}, $, {
        id: B
      }),
      infoProp: Object.assign({
        infoText: "",
        infoType: "tooltip",
        popupTipHeader: "Info"
      }, S),
      trailingText: w
    });
  }, M = function() {
    return /* @__PURE__ */ l(J, {
      defaultProp: Object.assign({
        id: T.defaultId
      }, (n == null ? void 0 : n.defaultProp) || {
        helperText: ""
      }),
      inputState: o,
      secondaryProp: o && o !== j.NONE ? Object.assign({}, n == null ? void 0 : n.secondaryProp, {
        id: T.secondaryId
      }) : void 0
    });
  };
  return /* @__PURE__ */ D(ve, Object.assign({
    className: u(["SelectionTileCompactGroup__MainWrapper"])
  }, k, h, {
    children: [E(), /* @__PURE__ */ l(Ce, {
      role: "listbox",
      "aria-labelledby": c,
      className: u(["SelectionTileCompactGroup-Wrapper"]),
      children: C.map(function(b, _) {
        var g = b.label, L = b.disabled, K = x(b, se);
        return /* @__PURE__ */ l(de, Object.assign({
          disabled: L
        }, K, {
          role: "option",
          "aria-roledescription": "option",
          selected: I === _,
          "aria-live": "polite",
          "aria-label": I === _ ? String(g).slice(0, 4) + " selected" : String(g).slice(0, 4),
          onClick: function(y) {
            N(y, _);
          },
          onKeyDown: function(y) {
            (y.code === "Enter" || y.code === "Space") && (y.preventDefault(), N == null || N(y, _));
          },
          isInvalid: o === j.ERROR,
          children: g
        }), _);
      })
    }), M()]
  }));
};
export {
  Po as SelectionCard,
  Io as SelectionTileCompactGroup
};
